// extracted by mini-css-extract-plugin
export default {"mathjaxContainer":"helper_mathjaxContainer__UA1xa"};